<template>
    <div class="tower-item" :class="{ right: index % 2 !== 0 }">
        <img
            class="base"
            :src="
                require(`@/assets/Stage/Tower/${type}/Level${level}/base-${
                    index % baseCycle
                }.png`)
            "
            alt=""
            width="45%"
        />
        <img
            class="item"
            :class="{ locked: !unlocked }"
            :src="
                require(`@/assets/Stage/Tower/${type}/Level${level}/${index}.png`)
            "
            alt=""
            width="45%"
        />
        <div v-if="!unlocked" class="item lock">
            <img src="@/assets/Stage/Tower/lock.png" alt="" width="60%" />
        </div>
        <img
            v-if="cursor === index"
            class="cursor"
            src="@/assets/Stage/Tower/cursor.png"
            alt=""
            width="20%"
        />
        <div class="goal">
            <div class="inner">達{{ goal }}分解鎖</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        unlocked: Boolean,
        cursor: Number,
        index: Number,
        baseCycle: Number,
    },
    computed: {
        ...mapGetters({
            getTrophyThreshold: 'config/getTrophyThreshold',
        }),
        type() {
            return (
                this.$route.params.type.charAt(0).toUpperCase()
                + this.$route.params.type.slice(1)
            );
        },
        level() {
            return (
                this.$route.params.level.charAt(0).toUpperCase()
                + this.$route.params.level.slice(1)
            );
        },
        goal() {
            const GAME = this.$route.params.type;
            const { level } = this.$route.params;
            const TrophyThreshold = this.getTrophyThreshold(GAME, level);
            return (this.index + 1) * TrophyThreshold;
        },
    },
};
</script>

<style lang="scss" scoped>
.tower-item {
    position: relative;
    display: flex;
    margin: 0 4em;
    transform: translateY(-20%);
    margin-top: -2em;
    min-height: 141px;
    &.right {
        justify-content: flex-end;
        .cursor {
            transform: translateX(-170%);
        }
        .goal {
            left: unset;
            right: 0;
        }
    }
    img {
        display: block;
    }
    .base {
        margin: 0;
    }
    .item {
        position: absolute;
        top: 0;
        &.locked {
            filter: brightness(0);
        }
        &.lock {
            transform: translateY(30%);
            width: 45%;
            height: fit-content;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .cursor {
        position: absolute;
        bottom: 35%;
        transform: translateX(-50%);
    }
    .goal {
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        width: 45%;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translateY(-50%);
        font-size: 13px;
        color: #fff;
        .inner {
            padding: 2px 0;
            width: 70%;
            background-color: #00000022;
            border-radius: 2px;
        }
    }
    @media screen and (max-width: 320px) {
        min-height: 120px;
        .goal {
            width: 50%;
        }
    }
}
</style>
